import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    getActiveTab,
    getAlarms,
    getAlarmsLoading,
    getAlarmsPagination, getLocations,
    installationSelect
} from "../../../redux-store/selectors";
import {Pagination, Table, Tooltip} from "antd";
import {timeStampToTimeString} from "../../../constants/FunctionJS";
import {fetchAlarms} from "../../../redux-store/alarms";
import blueIcon from "../../../images/blue-icon.png";
import redIcon from "../../../images/red-icon.png";
import greenIcon from "../../../images/green-icon.png";
import yellowIcon from "../../../images/yellow-icon.png";
import orangeIcon from "../../../images/orange-icon.png";
import {fetchLocationTableData, setLocation} from "../../../redux-store/map";
import {useNavigate} from "react-router-dom";

export const mapLevelToImage = {
    "GREEN": greenIcon,
    "BLUE": blueIcon,
    "YELLOW": yellowIcon,
    "ORANGE": orangeIcon,
    "RED": redIcon,
}

const AlarmsTable = () => {
    const dispatch = useDispatch();
    const navigation = useNavigate();

    const alarms = useSelector(getAlarms);
    const loading = useSelector(getAlarmsLoading);
    const locations = useSelector(getLocations);
    const {total, currentPage, pageSize} = useSelector(getAlarmsPagination);
    const installation = useSelector(installationSelect);
    const activeTab = useSelector(getActiveTab);

    const tableHeader = [
        {
            dataIndex: "level",
            key: "id",
            render: (text) => {
                return <img src={mapLevelToImage[text]} height={20}/>
            },
            width: "5%",
            align: 'center'
        },
        {
            title: <Tooltip title="Lokacija"><span>Lokacija</span></Tooltip>,
            dataIndex: "locationName",
            key: "locationName",
            render: (text, record) => {
                return <span className={"location-alarm-link"}><span className={`${record.clearedAt === null ? "fw-bold" : ""}`}
                                onClick={handleLocationDetails.bind(this, record.locationId)}>{text}</span></span>
            }
        },
        {
            title: <Tooltip title="Opis alarma"><span>Opis alarma</span></Tooltip>,
            dataIndex: "alarmText",
            key: "alarmText",
            render: (text, record) => {
                return <span className={`${record.clearedAt === null ? "fw-bold" : ""}`}>{text}</span>
            }
        },
        {
            title: <Tooltip title="Aktiviran"><span>Aktiviran</span></Tooltip>,
            dataIndex: "triggeredAt",
            key: "triggeredAt",
            render: (text, record) => <span
                className={`${record.clearedAt === null ? "fw-bold" : ""}`}>{timeStampToTimeString(text)}</span>
        },
        {
            title: <Tooltip title="Poništen"><span>Poništen</span></Tooltip>,
            dataIndex: "clearedAt",
            key: "clearedAt",
            render: (text, record) => {
                if (text === null) return "";
                return <span>{timeStampToTimeString(text)}</span>
            }
        },
    ]

    useEffect(() => {
        if (installation.value === null) return;
        
        dispatch(fetchAlarms({installationId: installation.value, page: 0}));
    }, [installation]);

    const handleLocationDetails = locationId => {
        const location = locations.find(location => location.id === locationId);
        if (location === undefined) return;
        dispatch(fetchLocationTableData({installationId: installation.value, locationId: location.id}));
        dispatch(setLocation(location));
        navigation("/location-devices")
    }
    return (
        <>
            <div className={"container-fluid"}>
                <div className={"row"}>
                    <div className={"col-12 p-unset"}>
                        <Table showSorterTooltip={false} columns={tableHeader} dataSource={alarms} size="small"
                               scroll={{
                                   x: 900,
                                   //y: 450,
                               }}
                               loading={loading}
                               pagination={false}
                        />
                        {total !== 0 && <div className={"row text-right pt-2 pb-4"}>
                            <Pagination defaultCurrent={1}
                                        current={currentPage + 1}
                                        total={total}
                                        showSizeChanger={false}
                                        onChange={(newPage, newPageSize) => {
                                            dispatch(fetchAlarms({
                                                installationId: installation.value,
                                                page: newPage - 1,
                                            }));
                                        }}
                                        defaultPageSize={pageSize}
                            />
                        </div>}

                    </div>
                </div>
            </div>
        </>
    );
};

export default AlarmsTable;